module.exports = __webpack_public_path__ + "static/leo-0a812a6171135754c0b13bd22e9473fa.jpeg";